



































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, NumberInput } from "../../../../../base/components/system";
import { ILineGraphBehavior, ILineGraphItem, TextObjectKinds, ExpressionKinds, ILineGraphLinkedObjectSpecifiable } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { TextObjectEditor, CalculateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component({
  components: {
    NumberInput,
  },
})
export default class LineGraphBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILineGraphBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILineGraphBehavior) => T, defaultValue: T) => T;

  @Prop()
  valueTypes: string[];

  @Prop()
  commonComponents: CommonComponentsContainer;

  get commonTimeAxis(): boolean {
    return this.readPropertyOrDefault(s => s.commonTimeAxis.isEnable, false);
  }

  set commonTimeAxis(value: boolean) {
    this.writePropertyWhenValid(s => s.commonTimeAxis = { isEnable: value });
  }

  get border(): boolean {
    return this.readPropertyOrDefault(s => s.border.isEnable, false);
  }

  set border(value: boolean) {
    this.writePropertyWhenValid(s => s.border = { isEnable: value });
  }

  get horizontalGrid(): boolean {
    return this.readPropertyOrDefault(s => s.horizontalGrid.isEnable, false);
  }

  set horizontalGrid(value: boolean) {
    this.writePropertyWhenValid(s => s.horizontalGrid = { isEnable: value, divisionCount: this.divisionCount });
  }

  get divisionCount(): number {
    return this.readPropertyOrDefault(s => s.horizontalGrid.divisionCount ? s.horizontalGrid.divisionCount : 0, 0);
  }

  set divisionCount(value: number) {
    this.writePropertyWhenValid(s => s.horizontalGrid = { isEnable: this.horizontalGrid, divisionCount: value });
  }

  get items(): ILineGraphItem[] {
    return this.readPropertyOrDefault(s => s.items, []);
  }

  set items(value: ILineGraphItem[]) {
    this.writePropertyWhenValid(s => s.items = value);
  }

  get selectionObjects(): { pageKey: number, object: IFormatObjectEditable }[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .where(o => this.conditionsOfLinkedObject(o) && this.conditionsOfFormatObject(o))
        .select(o => {
          return {
            pageKey: p.pageKey,
            object: o,
          };
        })
        .toArray())
      .toArray();
  }

  private conditionsOfLinkedObject(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
  }

  private conditionsOfFormatObject(object: IFormatObjectEditable): boolean {
    const typeName = object.objectTypeName().getValue();
    switch (typeName) {
      case "text":
        return Enumerable.from(this.valueTypes).any(v => v === typeName) &&
          object instanceof TextObjectEditor &&
          object.objectKind().getValue() === TextObjectKinds.Number;
      case "calculate":
        return Enumerable.from(this.valueTypes).any(v => v === typeName) &&
          object instanceof CalculateObjectEditor &&
          object.kind().getValue() === ExpressionKinds.Calculation;
      case "date":
        return true;
      default:
        return false;
    }
  }

  private toPageNumberCellString(row: ILineGraphLinkedObjectSpecifiable): string {
    const pageNumber = this.commonComponents.getPageNumber(row.page);
    return pageNumber === 0 ? "削除済" : pageNumber.toString();
  }

  async showLineGraphItemEditDialog() {
    const dialog = this.commonComponents.getDialogs().getLineGraphItemEditDialog();
    const lineGraphItems = await dialog.show(this.items, this.selectionObjects, this.toPageNumberCellString);
    if (!lineGraphItems) { return; }
    this.items = lineGraphItems;
  }
}
